/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ThresholdConfig } from './ThresholdConfig';
import {
    ThresholdConfigFromJSON,
    ThresholdConfigFromJSONTyped,
    ThresholdConfigToJSON,
} from './ThresholdConfig';

/**
 * 
 * @export
 * @interface FormSectionResponse
 */
export interface FormSectionResponse {
    /**
     * 
     * @type {string}
     * @memberof FormSectionResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FormSectionResponse
     */
    sectionSnapshotId?: string;
    /**
     * 
     * @type {string}
     * @memberof FormSectionResponse
     */
    question?: string;
    /**
     * 
     * @type {string}
     * @memberof FormSectionResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof FormSectionResponse
     */
    sectionType?: FormSectionResponseSectionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FormSectionResponse
     */
    index?: number;
    /**
     * 
     * @type {string}
     * @memberof FormSectionResponse
     */
    guidanceImageUrl?: string;
    /**
     * 
     * @type {ThresholdConfig}
     * @memberof FormSectionResponse
     */
    thresholds?: ThresholdConfig;
}


/**
 * @export
 */
export const FormSectionResponseSectionTypeEnum = {
    StatusCheck: 'STATUS_CHECK',
    NumberEntry: 'NUMBER_ENTRY',
    TextResult: 'TEXT_RESULT'
} as const;
export type FormSectionResponseSectionTypeEnum = typeof FormSectionResponseSectionTypeEnum[keyof typeof FormSectionResponseSectionTypeEnum];


/**
 * Check if a given object implements the FormSectionResponse interface.
 */
export function instanceOfFormSectionResponse(value: object): value is FormSectionResponse {
    return true;
}

export function FormSectionResponseFromJSON(json: any): FormSectionResponse {
    return FormSectionResponseFromJSONTyped(json, false);
}

export function FormSectionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormSectionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'sectionSnapshotId': json['sectionSnapshotId'] == null ? undefined : json['sectionSnapshotId'],
        'question': json['question'] == null ? undefined : json['question'],
        'description': json['description'] == null ? undefined : json['description'],
        'sectionType': json['sectionType'] == null ? undefined : json['sectionType'],
        'index': json['index'] == null ? undefined : json['index'],
        'guidanceImageUrl': json['guidanceImageUrl'] == null ? undefined : json['guidanceImageUrl'],
        'thresholds': json['thresholds'] == null ? undefined : ThresholdConfigFromJSON(json['thresholds']),
    };
}

export function FormSectionResponseToJSON(value?: FormSectionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'sectionSnapshotId': value['sectionSnapshotId'],
        'question': value['question'],
        'description': value['description'],
        'sectionType': value['sectionType'],
        'index': value['index'],
        'guidanceImageUrl': value['guidanceImageUrl'],
        'thresholds': ThresholdConfigToJSON(value['thresholds']),
    };
}

